import React from 'react';
import { Col, Input, UncontrolledTooltip } from 'reactstrap';
import classnames from 'classnames';

const ItemList = ({
  index,
  dragRef,
  previewRef,
  handlerId,
  isDragging,
  answer,
  error,
  onChangeAnswer,
  showConfirmation,
  removeItem,
  className,
  disabled
}) => {
  return (
    <div
      className={classnames(
        'row row--answers',
        { 'sortable-row row--answers--with-delete': !disabled },
        className
      )}
      ref={previewRef}
      data-handler-id={handlerId}
      style={{ opacity: isDragging ? 0 : 1 }}>
      {!disabled && (
        <Col>
          <div
            ref={dragRef}
            className={classnames('sortable-row__pointer', {
              'sortable-row__pointer--dragging': isDragging
            })}>
            <i className="fas fa-sort"></i>
          </div>
        </Col>
      )}
      <Col>
        <Input
          value={answer.answer}
          disabled={disabled}
          invalid={error && !answer.answer}
          onChange={(e) => {
            onChangeAnswer(index, 'answer', e.target.value);
          }}
          placeholder="Answer Text"
        />
      </Col>
      {!disabled && (
        <Col>
          <button
            type="button"
            className="table-action table-action-delete"
            id={`tooltip-delete-${answer.id}`}
            onClick={(e) => {
              e.preventDefault();
              showConfirmation({
                title: 'Are you sure want to delete?',
                confirmTitle: 'Delete',
                onConfirm: () => {
                  removeItem(index);
                }
              });
            }}>
            <i className="fas fa-trash" />
          </button>
          <UncontrolledTooltip delay={0} target={`tooltip-delete-${answer.id}`}>
            Delete Answer
          </UncontrolledTooltip>
        </Col>
      )}
    </div>
  );
};

export default ItemList;
